import _toConsumableArray from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.splice.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { savePhday as _savePhday, getPhday as _getPhday } from 'api/Attendance';
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;
    var self = this;
    var year = JSON.stringify(new Date().getFullYear());
    var yearPptions = [];
    for (var i = 0; i < 10; i++) {
      yearPptions.push({
        label: Number(year) + i + '',
        value: Number(year) + i + ''
      });
    }
    return {
      // 用户当前日期
      date: new Date(),
      // 存储时使用的参数
      form: {
        date_list: [],
        year_at: year
      },
      dateList: [],
      tableData: [{}],
      // 日期选择控制器
      pickerOptions: {
        /**
         *  日期选择器可选范围
         *  1. 年份必须为上边年份选择器的年份
         *  2. 日期必须大于当前日期（使用时的时间）
         */
        disabledDate: function disabledDate(date) {
          return Number(self.form.year_at) !== date.getFullYear() || date.getTime() <= _this.$util.getTime(-1);
        }
      },
      yearPptions: yearPptions
    };
  },
  computed: {
    saveDisabled: function saveDisabled(vm) {
      return !vm.tableData.filter(function (v) {
        return v.start;
      }).length;
    },
    // form.year_at 的年份 跟 当前年份 对比
    isCurYear: function isCurYear(vm) {
      return Number(vm.form.year_at) === new Date().getFullYear();
    }
  },
  watch: {
    visible: function visible(v) {
      if (v) {
        this.getPhday();
        this.init();
      }
    },
    // 在当前年 历史假期不能删除，要置灰
    tableData: {
      handler: function handler(arr) {
        var _this2 = this;
        if (this.isCurYear) arr.forEach(function (v) {
          return v.isDisabled = new Date(v.start) <= _this2.$util.getTime(-1);
        });
      }
    }
  },
  methods: {
    init: function init() {
      this.form = {
        date_list: [],
        year_at: JSON.stringify(new Date().getFullYear())
      };
      this.tableData = [];
    },
    // 关闭dialog
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    },
    // 添加数据
    handleraddData: function handleraddData(index) {
      var item = this.isCurYear ? {} : {
        start: this.form.year_at + '-01-01'
      };
      this.tableData.insert(index + 1, item);
    },
    // 获取日期
    getPhday: function getPhday() {
      var _this3 = this;
      var msg = {
        year_at: this.form.year_at
      };
      _getPhday(msg).then(function (res) {
        _this3.tableData = res.data.map(function (item) {
          return {
            start: item
          };
        });
        if (_this3.tableData.length < 1) _this3.tableData = [{
          start: _this3.form.year_at + '-01-01'
        }];
      });
    },
    // 保存假期
    savePhday: function savePhday() {
      var _this4 = this;
      this.form.date_list = this.tableData.map(function (item) {
        return item.start;
      });
      if (_toConsumableArray(new Set(this.form.date_list)).length === this.tableData.length) {
        _savePhday(this.form).then(function () {
          _this4.init();
          _this4.$emit('update:visible', false);
        });
      } else {
        this.$confirm(this.$t('1700'), this.$t('229'), {
          confirmButtonText: this.$t('131'),
          cancelButtonText: this.$t('66'),
          type: 'warning'
        }).then(function () {
          _savePhday(_this4.form).then(function () {
            _this4.init();
            _this4.$emit('update:visible', false);
          });
        }).catch(function () {});
      }
    },
    // 切换年
    handlerChangeYear: function handlerChangeYear() {
      this.getPhday();
    },
    handlerDeleteData: function handlerDeleteData(index) {
      this.tableData.splice(index, 1);
    }
  }
};